/**
 * ATNA Logging API Documentation
 * Rest API used to query log entries
 *
 * OpenAPI spec version: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from "./XHR"
import { User } from '../model/User';


export class IccUserApi {
  host: string
  headers: Array<XHR.Header>
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  constructor(host: string, headers: any, fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>) {
    this.host = host
    this.headers = Object.keys(headers).map(k => new XHR.Header(k, headers[k]))
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this.headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }


     /**
      * Requires admin rights: Create a user that can query atna logs
      * @summary Create user
      * @param body 
      */
 create(body?: User): Promise<any | Boolean> {
    let _body = null
    _body = body

    const _url = this.host + `/users/create` + "?ts=" + new Date().getTime() 
    let headers = this.headers
    headers = headers.filter(h => h.header !== "Content-Type").concat(new XHR.Header("Content-Type", "application/json"))
    return XHR.sendCommand("POST", _url, headers, _body, this.fetchImpl)
      .then(doc =>       (true))
      .catch(err => this.handleError(err))
}

     /**
      * Get currently logged user that can query atna logs
      * @summary Get current
      */
 current(): Promise<User> {
    let _body = null
    
    const _url = this.host + `/users/current` + "?ts=" + new Date().getTime() 
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new User(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}
}

